import { makeObservable, observable, action } from 'mobx';
import type { RootStore } from './RootStore';

// One drawer-open-state shared across the app. Any component can call
// helpStore.open('knowledge.rag') to surface the matching topic.

export class HelpStore {
  @observable openTopic: string | null = null;

  constructor(_root: RootStore) {
    void _root;
    makeObservable(this);
  }

  @action open(topic: string): void {
    this.openTopic = topic;
  }

  @action close(): void {
    this.openTopic = null;
  }
}
